import { BrowserRouter } from "react-router-dom";

import { WithAppInsightsContext } from "utils/azureAD/WithAppInsightsContext";
import { WithTraceLogger } from "utils/AppInsightsManager/WithTraceLogger";
import IosPWAPrompt from "Shared.Components/IosPwaPrompt/IosPWAPrompt";
import { WithAuthentication } from "utils/azureAD/WithAuthentication";
import "Layouts/Common/fontAwesome";
import "utils/i18n/i18nManager";
import App from "./App";

import "./index.scss";
import "./toast.scss";

export const AppProviders = () => {
  return (
    <WithAuthentication>
      <WithAppInsightsContext>
        <WithTraceLogger>
          <BrowserRouter>
            <App />
          </BrowserRouter>
          <IosPWAPrompt />
        </WithTraceLogger>
      </WithAppInsightsContext>
    </WithAuthentication>
  );
};
